module.exports = __webpack_public_path__ + "img/4b6dd141c5ec667699ad4e7d340fa9fa.png";